import {PBEnhancedContentCard, ContentCardBanner} from "../../ContentCard"

/**
 * Get a list of Banner components from a list of content Cards
 * TODO: some of these filters can be lifted up and shared
 */
export function filterBanners(cards: PBEnhancedContentCard[]): ContentCardBanner[] {
  return cards
    .filter((c): c is ContentCardBanner => c.extras.component_id === "banner" && !!c.extras.banner)
    .map((c) => {
      const {banner, popup} = c.extras

      // this is to remove external links if the popup has been defined
      if (banner?.linkedComponent === "popup" && popup && banner.ctaUrlExternal) {
        return {
          ...c,
          extras: {
            ...c.extras,
            banner: {
              ...banner,
              ctaUrlExternal: undefined,
              ctaUrl: undefined
            }
          }
        }
      } else {
        return c
      }
    })
}
